module.exports = __webpack_public_path__ + "img/legendWard.52a5bcac.svg";